import React, { Fragment, useEffect, useState } from 'react';
import axios from 'axios';
import Header from './Header';
import ResignationList from './ResignationList';
import { CommonLoading } from 'react-loadingg';

const Resignation = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [resignation, setResignation] = useState([]);
    const [exitFormData, setExitFormData] = useState([]);
    const [updatedResignation, setUpdatedResignation] = useState([]);
    const [hodCommentFormData, setHodCommentFormData] = useState([]);
    const { REACT_APP_API_BACKEND_URL, REACT_APP_API_BACKEND_URL_EXIT_FORM } = process.env;


    // Validate permissions when component mounts
    useEffect(() => {
        const loginListFromParent = props.loginList;

        const permit = loginListFromParent.some(
            (item) =>
                (item.permissionName.includes('Admin Role') &&
                    item.permissionType.includes('view')) ||
                (item.permissionName.includes('Resignation') &&
                    item.permissionType.includes('view'))
        );

        if (!permit) {
            alert('You have no permissions to access this page.');
            window.location = '/';
        } else {
            setIsLoading(false);
        }
    }, [props.loginList]);

    // Fetch resignation data
    const fetchResignation = async () => {
        try {
            const res = await fetch(`${REACT_APP_API_BACKEND_URL}/api/resignation/getresignationlist`);
            const data = await res.json();
            return data.ResignList || [];
        } catch (err) {
            console.error('Error fetching resignation data:', err);
            return [];
        }
    };

    // Fetch exit form data
    const fetchExitFormData = async () => {
        try {
            const response = await axios.get(
                REACT_APP_API_BACKEND_URL_EXIT_FORM + 'exit/interview/form',
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                    }
                }
            );
            return response.data || [];
        } catch (err) {
            console.error('Error fetching exit form data:', err);
            return [];
        }
    };
    // Fetch exit form data
    const fetchHODCommentForm = async () => {
        try {
            const response = await axios.get(
                REACT_APP_API_BACKEND_URL_EXIT_FORM+'hod/comment/form',
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                    }
                }
            );
            return response.data || [];
        } catch (err) {
            console.error('Error fetching exit form data:', err);
            return [];
        }
    };
    // Fetch data and set state
    useEffect(() => {
        const fetchData = async () => {
            try {
                const resignationData = await fetchResignation();
                const exitFormData = await fetchExitFormData();
                const hodCommentFormData = await fetchHODCommentForm();
                console.log(hodCommentFormData)
                setResignation(resignationData);
                setExitFormData(exitFormData);
                setHodCommentFormData(hodCommentFormData);
                console.log(hodCommentFormData)
          
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        fetchData();
    }, []);

    // Compare and insert formAction
    const compareAndInsertFormAction = () => {
        if (resignation.length > 0 ) {
       
            const updatedList = resignation.map((resignationItem) => {
                const matchingExitFormItem = exitFormData.find(
                    (exitItem) => exitItem.userBadgeId === resignationItem.userID
                );

                const matchingHodCommentFormItem = hodCommentFormData.find(
                    (hodItem) => hodItem.userBadgeId === resignationItem.userID
                );

                let updatedResignationItem = { ...resignationItem };
    
                if (matchingExitFormItem) {
                    updatedResignationItem.formAction = matchingExitFormItem.formAction;
                    updatedResignationItem.joinDate = matchingExitFormItem.joinDate;
                    updatedResignationItem.positionUser = matchingExitFormItem.position;
           
                }
    
                if (matchingHodCommentFormItem) {
                    updatedResignationItem.formActionHOD = matchingHodCommentFormItem.formAction;
                    updatedResignationItem.lastPerformance = matchingHodCommentFormItem?.lastPerformance;
                    updatedResignationItem.periodFrom = matchingHodCommentFormItem?.periodFrom;
                    updatedResignationItem.periodTo = matchingHodCommentFormItem?.periodTo;
                    updatedResignationItem.bmi = matchingHodCommentFormItem?.bmi;
                    updatedResignationItem.medicalCert = matchingHodCommentFormItem?.medicalCert;
                    updatedResignationItem.unpaidLeave = matchingHodCommentFormItem?.unpaidLeave;
                    updatedResignationItem.hospLeave = matchingHodCommentFormItem?.hospLeave;
                    updatedResignationItem.emergencyLeave = matchingHodCommentFormItem?.emergencyLeave;
                    updatedResignationItem.absenteeism = matchingHodCommentFormItem?.absenteeism;
                    updatedResignationItem.warningLetter = matchingHodCommentFormItem?.warningLetter;
                    updatedResignationItem.rewardLetter = matchingHodCommentFormItem?.rewardLetter;
                    updatedResignationItem.suggestion = matchingHodCommentFormItem?.suggestion;
                    updatedResignationItem.trainingLetter = matchingHodCommentFormItem?.trainingLetter;
                    updatedResignationItem.reminderLetter = matchingHodCommentFormItem?.reminderLetter;
                    updatedResignationItem.requestBy = matchingHodCommentFormItem?.requestBy;
                    updatedResignationItem.requestorName = matchingHodCommentFormItem?.requestorName;
                    updatedResignationItem.requestorUsername = matchingHodCommentFormItem?.requestorUsername;
                    updatedResignationItem.assignBadgeIdHod = matchingHodCommentFormItem?.assignBadgeIdHod;
                    updatedResignationItem.hodPosition = matchingHodCommentFormItem?.hodPosition;
                    updatedResignationItem.hodUsername = matchingHodCommentFormItem?.hodUsername;

                }

                return updatedResignationItem;
            });
            console.log("RESIGNATION LIST HERE !!");
            console.log(updatedList)
            setUpdatedResignation(updatedList);
        } else {
            console.warn('Data arrays are empty or missing.');
        }
    };
    

    // Run compareAndInsertFormAction when data is available
    useEffect(() => {
        compareAndInsertFormAction();
    }, [resignation, exitFormData,hodCommentFormData]);

    const ResignationTable = () => {
        return (
            <Fragment>
                {updatedResignation?.length > 0 ? (
                    <ResignationList resignation={updatedResignation} {...props} />
                ) : (
                    <div>No resignation to show</div>
                )}
            </Fragment>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div className={`${props.isActive ? 'container is-active' : 'container-fluid'}`}>
                        <Header />
                        <div className='table-wrapper'>
                            <ResignationTable />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default Resignation;
